import React from "react";

import LogsFilter from "~/pages/Logs/components/LogsFilter";

import { integrationsLogsFilterFields } from "./fields";

const IntegrationsLogsFilter = () => (
  <LogsFilter fields={integrationsLogsFilterFields} />
);

export default IntegrationsLogsFilter;
